import { months, weekdays } from '../strings.fi';

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  ordersOverview: {
    modalHeader: 'Tilauksen tiedot',
    formFilterHeader: 'Suodata',
    formFilterOrdersHeader: 'Suodata tilaukset',
    filterInputPlaceholder: 'Hae osoite',
    mapMenuButton: 'Tilauksen tiedot',
    importPlannedDates: 'Tuo Suunnitellut Päivämäärät',
    importSuccess: 'Suunnitellut päivämäärät päivitetty',
    importError: 'Tuonti epäonnistui. Yritä uudelleen',
    downloadExcel: 'Lataa Excel',
    downloadSuccess: 'Excel ladattu',
    downloadError: 'Excel-tiedostoa ei voitu ladata.',
    downloadPdfStarted:
      'Luodaan PDF osoitteelle {address}. PDF:n luominen voi kestää hetki riippuen raportin koosta.',
    downloadPdfSuccess: 'PDF ladattu',
    downloadPdf429Title: 'Odota hetki',
    downloadPdfError429:
      'PDF:n luominen on varattu. Odota hetki ja yritä uudelleen.',
    downloadPdfErrorGeneric: 'PDF:n luominen epäonnistui. Yritä uudelleen.',
    downloadPdfCancelled: 'PDF-lataus peruutettiin, koska taulukko suljettiin.',
    filterOptions: {
      showAll: 'Näytä kaikki',
      incomplete: 'Näytä epätäydelliset',
      complete: 'Esitys valmis',
    },
    tableHeaders: {
      latestStatus: ' Viimeisin tila',
      customerType: 'Tyyppi',
      statusDate: 'Tila pvm.',
      address: 'Kiinteistön osoite',
      customerName: 'Asiakkaan nimi',
      completedDate: 'Valmistumispäivämäärä',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Asennuspäivämäärä',
      pdf: 'PDF',
      planedInstallationDate: 'Suunniteltu asennus',
      bookedCustomerInstallationDate: 'Sovittu asennus',
      siteProjectPlanningExecutedDate: 'Site project planning executed',
      siteShaftBooked: 'Site shaft booked',
      siteShaftInstallationDate: 'Site shaft installation',
      fiberCableInstalledForCustomer: 'Kuitukaapeli asennettu',
      fiberReceiverInstallationDate: 'Kuitupäätelaitteen asennus',
      plotDesignDate: 'Tonttisuunnittelu',
      preinstallationDate: 'Esiasennus',
      plotExcavationDate: 'Tonttikaivuu',
      ductConnection: 'Kanavakytkennät',
      cableBlowingDate: 'Kuidun puhallus',
      splicingAndMeasuringDate: 'Hitsaus & Mittaus',
      splicingAndMeassuringDate: 'Hitsaus & Mittaus',
      splicingDate: 'Hitsaus',
      commissioningDate: 'Käyttöönotto',
      measuringDate: 'Mittaus',
      macAddress: 'MAC-Osoite CPE',
      macNetAdminId: 'MAC & NetAdmin ID',
      buildingName: 'Rakennuksen nimi',
      buildingId: 'Rakennuksen tunnus',
      deliveryPoints: 'Toimituspisteet (toimitetut/yhteensä)',
    },
    latestStatus: {
      ORDERED: 'Tilattu',
      ORDERED_FOR_BUILD: 'Tilattu rakentamiseen',
      CANCELLED: 'Peruutettu',
      REVOKED: 'Kumottu',
      WITHDRAWN: 'Sulkeutunut',
      ESCALATED: 'Eskaloitunut',
      CONSTRUCTION_DEVIATION: 'Rakennuspoikkeama',
      NOT_VALIDATED: 'Ei validoitu',
      WARNING: 'Varoitus',
      INSTALLED: 'Asennettu',
      UNKNOWN: 'Tuntematon',
    },
    true: 'Joo',
    false: 'Ei',
    error: 'Tilauksia ei voitu ladata, yritä myöhemmin uudelleen',
    status: 'Tila',
    reportDetails: {
      true: 'Joo',
      false: 'Ei',
      deliveryPoints: 'Toimituspisteet',
      itemPerPage: 'Numero per sivu',
      labels: {
        address: 'Osoite',
        propertyDesignation: 'Kiinteistötunnus',
        deliveryContact: 'Toimituksen yhteyshenkilö',
        phone: 'Puhelinnumero',
        email: 'Sähköposti',
        housingNetwork: 'Asumisverkosto',
        netType: 'Verkkotyyppi',
        propertyConnection: 'Kiinteistöliittymä',
        connectionType: 'Yhteystyyppi',
        propertyNetwork: 'Verkon rakentaminen',
      },
      propertyNetwork: {
        EXISTING: 'Olemassa oleva',
        CONSTRUCTION: 'Rakentaminen',
      },
      networkType: {
        OWN_NETWORK: 'Oma verkko',
        KO: 'Viestintäoperaattori',
        ACQUIRED: 'Hyväksytty',
        RENTAL: 'Vuokraus',
      },
      connectionType: {
        ONGOING_CONSTRUCTION_AREA: 'Työmaa-alue',
        EXISTING: 'Olemassa oleva',
        RENT: 'Vuokrata',
        KO: 'Viestintäoperaattori',
      },
      constructionType: {
        HANDED_TO_CONSTRUCTION: 'Luovutettu rakentamiseen',
        STARTED: 'Aloitettu',
        FINISHED: 'Valmis',
        OBSTRUCTION: 'Estäminen',
        PLANNED: 'Suunniteltu',
        MIGRATION_ONGOING: 'Siirto käynnissä',
        MIGRATED: 'Siirretty',
      },
      constructionStatus: {
        utbyggnad: 'Laajennus',
        HANDED_TO_CONSTRUCTION: 'Luovutettu rakentamiseen',
        STARTED: 'Aloitettu',
        FINISHED: 'Valmis',
        OBSTRUCTION: 'Estäminen',
        PLANNED: 'Suunniteltu',
        MIGRATION_ONGOING: 'Siirto käynnissä',
        MIGRATED: 'Siirretty',
      },
    },
    deliveryPointsTable: {
      mac: 'MAC',
      id: 'ID',
    },
  },
  installationReport: {
    popUpBtnText: 'Asennuksen raportointi',
    header: 'Asennuksen raportointi',
    saveBtn: 'Tallenna raportti',
    dismissBtn: 'Sulje',
    addressLabel: 'Katuosoite',
    toOrdersModal: 'Tilausten yleiskatsaukseen',
    confirmModal: {
      header: 'Haluatko varmasti sulkea lomakkeen?',
      text: 'On tallentamattomia muutoksia. Muista Tallenna ne ennen modaalin sulkemista.',
      cancelBtn: 'Vie minut takaisin raporttiin',
      closeBtn: 'Joo, sulje!',
    },
    missingIdMessage:
      'Edistymissuunnitteluraportin tunnus puuttuu (lähdeavain)',
    saveSuccessMessage:
      'Edistymisen suunnitteluraportti tallennettu onnistuneesti',
    saveErrorMessage:
      'Edistymissuunnitteluraporttia ei voitu tallenna. Yritä uudelleen.',
    failToLoadMessage: {
      403: 'Pääsy kielletty, kirjaudu sisään nähdäksesi edistymissuunnitteluraportti.',
      404: 'Asunnosta ei ole saatavilla sijaintisuunnitteluraporttia.',
      408: 'Pyynnön aikakatkaisu. Päivitä sovellus uudelleen.',
      500: 'Palvelinongelmia, yritä myöhemmin uudelleen.',
      general: 'Edistymissuunnitteluraporttia ei voitu ladata.',
    },
    errorText:
      'Raporttia ei voitu ladata. Lataa raportti uudelleen tai yritä myöhemmin uudelleen.',
    form: {
      planedInstallationDate: 'Suunniteltu asennuspäivämäärä',
      bookedCustomerInstallationDate: 'Varattu asiakkaan asennuspäivä',
      siteProjectPlanningExecutedDate: 'Projektisuunnittelun toteutuspäivä',
      siteShaftBooked: 'Kohteen kaivaus varattu ',
      siteShaftInstallationDate: 'Kaivauksen asennuspäivämäärä',
      fiberCableInstalledForCustomer: 'Asiakkaalle asennettu kuitukaapeli',
      fiberReceiverInstallationDate: 'Kuituvastaanottimen asennuspäivämäärä',
      macAddress: 'MAC-Osoite CPE',
      email: 'Sähköposti',
      name: 'Nimi',
      phoneNumber: 'Puhelinnumero',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Tilauksen tiedot',
      PLOT_DESIGN: 'Tonttisuunnittelu',
      PLOT_EXCAVATION: 'Tonttikaivuu',
      DUCT_CONNECTION: 'Kanavakytkennät',
      PRE_INSTALLATION: 'Esiasennus',
      SPLICING_MEASURING: 'Hitsaus & Mittaus',
      SPLICING: 'Hitsaus',
      COMMISSIONING: 'Käyttöönotto',
      CABLE_BLOWING: 'Kuidun puhallus',
      MEASURING: 'Mittaus',
    },
    modal: {
      header: 'Asennuksen raportointi',
      completedBy: 'Valmistunut: #{user} #{date}',
      closeBtn: 'Sulje',
      saveBtn: 'Tallenna',
      completeBtn: 'Täydellinen raportti',
      unlockReportBtn: 'Avaa raportin lukitus',
      reportCompletedBtn: 'Raportti valmis',
      reportCompletedDisabledTooltip:
        'Ota yhteyttä rakennusvastaavaasi, jotta raportin lukitus voidaan poistaa.',
      completeBtnDisabledTooltip:
        'Raportin voi viimeistellä, kun kaikki vaiheet on saatettu loppuun.',
      onProceedError: 'Lomake ei kelpaa',
      cannotSaveNetAdmin: 'NetAdmin-arvoa ei voi tallentaa.',
    },
    completeConfirmation: {
      title: 'Viimeistelläänkö raportti?',
      whatHappens: 'Mitä tapahtuu, jos vahvistat?',
      bulletInvoice: 'Asiakas laskutetaan suoraan vahvistuksen jälkeen.',
      bulletLocked: 'Koko raportti lukitaan eikä sitä voi muuttaa.',
      checkboxLabel: 'Olen lukenut ja ymmärtänyt yllä olevan tekstin.',
      cancel: 'Peruuta',
      confirm: 'Vahvista',
      completedTitle: 'Raportti valmis!',
      completedBody:
        'Asiakas on tilattu ja lasku on lähetetty! Tätä raporttia ei voi enää muokata.',
      closeWindow: 'Sulje tämä ikkuna',
    },
    plotDesignTab: {
      instructions: 'Täytä tiedot jatkaaksesi',
      completed: 'Tonttisuunnittelu - Valmis!',
      plannedPlotDesign: 'Suunniteltu Tonttisuunnittelu',
      executedPlotDesign: 'Toteutettu Tonttisuunnittelu',
      comment: 'Kommentit',
      awaitingSign: 'Awaiting sign',
      completedSign: 'Allekirjoitus suoritettu',
      initiateSign: 'Aloita allekirjoittaminen',
    },
    plotExcavationTab: {
      instructions: 'Täytä tiedot jatkaaksesi',
      completed: 'Tonttikaivuu - Valmis!',
      plannedPlotExcavation: 'Suunniteltu Tonttikaivuu',
      executedPlotExcavation: 'Toteutettu Tonttikaivuu',
      comment: 'Kommentit',
    },
    ductConnectionTab: {
      instructions:
        'Suorita itsetarkastukset kanavayhteyden viimeistelemiseksi!',
      completed: 'Kanava yhdistetty',
      executedDate: 'Täytäntöönpanopäivä',
      notConnected: 'Ei yhteyttä',
      comment: 'Kommentit',
    },
    orderOverviewTab: {
      markAsBom: 'Merkitse BOM:ksi',
      bomTag: 'BOM',
      comment: 'Kommentti',
      commentPlaceholder: 'Kommentti...',
      save: 'Tallenna',
      cancel: 'Peruuta',
      undoBom: 'Peru BOM',
      markAsBomError: 'Toimituspisteen merkitseminen BOM:ksi epäonnistui',
      undoBomError: 'Toimituspisteen BOM-merkinnän peruminen epäonnistui',
      infoText:
        'Valitun tilauksen tiedot näytetään alla. Täytä raportit välilehtiin yllä.',
      subHeader: 'Tilaus Informaatio',
      address: 'Katuosoite',
      customerName: 'Asiakkaan nimi',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      connectionType: 'Liittymätyyppi',
      contactedDate: 'asiakaskontakti',
      statusReport: 'Raportin tilanne',
      customerType: 'Mahdollisuustyyppi',
      greenfieldIfs: 'Greenfield-IFS',
      greenfieldProjectAccessDeniedHeading: 'Projektin käyttöoikeus vaaditaan',
      greenfieldProjectAccessDeniedMessage:
        'Sinulla ei ole käyttöoikeutta tähän projektiin. Ota yhteyttä järjestelmänvalvojaan, jos tarvitset käyttöoikeuden.',
      greenfieldProjectAccessDeniedClose: 'Sulje',
      doneTag: 'TYHJENNÄ',
    },
    preinstallationTab: {
      instructions: 'Näytä tiedot ja suorita tarkistus',
      completed: 'Esiasennus - Valmis!',
      plannedPreinstallation: 'Suunniteltu Esiasennus',
      executedPreinstallation: 'Toteutettu Esiasennus',
      macAddress: 'MAC-Osoite CPE / sarjanumero',
      macAddressInputLabel:
        'MAC-osoite CPE (P2P) tai Serienummer ONT (XGS-PON)',
      help: 'Apu',
      comment: 'Kommentit',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE-rekisteröinti',
      netAdminSubHeader:
        'Valitse laite ja täytä arvo alla. Tallenna rekisteröidäksesi!',
      deviceCategory: 'Laitetyyppi',
      deviceValue: 'Laitearvo',
      macSerialPlaceholder: 'MAC / Sarjanumero',
      mustMatchFormat: 'Muodon on vastattava:',
      netAdminStatus: {
        saveToUpload:
          'Täytä MAC-osoite CPE / Sarjanumero ja tallenna ladataksesi!',
        notSaved: 'Ei tallennettu',
        cannotUpload:
          'Tallennettu - mutta ei voi ladata ilman suorituspäivää ja suoritettuja itsetarkastuksia.',
        clickSave: 'Lataa NetAdminiin napsauttamalla Tallenna!',
        uploading: 'MAC-osoite CPE / Sarjanumero on lähetetty NetAdminille!',
        uploaded: 'Lähetetty ja tallennettu',
      },
      inputPlaceHolder: 'MAC-osoite CPE tai Sarjanumero',
      maxInput: 'Enintään 17 merkkiä sallittu.',
      incorrectFormat: 'Virheellinen muoto, katso Ohjeet ohjeita varten.',
      snackbarInfo:
        'Jos haluat muuttaa nykyistä arvoa, ota yhteyttä vastaavaan GlobalConnectin projektipäällikköön',
      model: 'Malli',
      selection: 'Valinta',
    },
    splicingAndMeasuringTab: {
      instructions: 'Täytä tiedot ja lataa tiedostot!',
      completed: 'Hitsaus & Mittaus - Valmis!',
      plannedMeasuring: 'Suunniteltu mittaus',
      executedMeasuring: 'Toteutettu mittaus',
      plannedSplicing: 'Suunniteltu hitsaus',
      executedSplicing: 'Toteutettu hitsaus',
      fileAndImageUpload: 'Tiedoston ja kuvan lataus',
      upload: 'Lataa',
      showImages: 'Näytä kuvat',
      comment: 'Kommentit',
      commentDescriptionExplanation:
        'Kerro syy, miksi et seuraa paneelikorttia.',
      fiberData: {
        title: 'Kuitutiedot',
        panelcard: {
          question: 'Onko Panelcardia noudatettu?',
          yes: 'Kyllä',
          no: 'Ei',
        },
        switchName: 'Kytkimen nimi',
        switchPort: 'Kytkinportti',
        switchCard: 'Kytkinkortti',
        odfInSite: 'ODF aktiivilaitepaikassa',
        odfContact: 'ODF liitin',
        cabinet: 'JK (jakokaappi) / VKJK (valokuitujakokaappi)',
        cableIdCabinet: 'VKJK (valokuitujakokaappi)',
        fiberInCabinet: 'Kuitu JK:ssa / VKJK:ssa',
        ductColorInCabinet: 'Putken väri JK:ssa / VKJK:ssa',
        splitterPort: 'Jakajan portti',
        splitterName: 'Jakajan nimi',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Number',
          focType: 'Type FOC',
          focCableId: 'Type Cable ID',
          color: 'Type duct color',
          name: 'Kirjoita nimi',
          select: 'Valitse',
        },
        descriptions: {
          switchNameSyntax: 'Suositeltu muoto NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Kerro kommentissa syy, miksi et seuraa paneelikorttia.',
      },
    },
    commissioningTab: {
      instructions: 'Täytä tiedot ja lataa tiedostot!',
      completed: 'Käyttöönotto - Valmis!',
      plannedCommissioning: 'Suunniteltu Käyttöönotto',
      executedCommissioning: 'Toteutettu Käyttöönotto',
      plannedMeasuring: 'Suunniteltu Mittaus',
      executedMeasuring: 'Toteutettu Mittaus',
      comment: 'Kommentit',
    },
    cableBlowingTab: {
      instructions: 'Täytä tiedot suorittaaksesi tämän hetken.',
      completed: 'Cable Blowing - Completed!',
      plannedCableBlowing: 'Suunniteltu Käyttöönotto',
      executedCableBlowing: 'Toteutettu Käyttöönotto',
      comment: 'Kommentit',
    },
    selfInspection: {
      markAsComplete: 'Merkitse tehdyksi',
      uploadImage: 'Lataa kuva',
      showControlled: 'Näytä tarkistetut',
      undoSelfInspection: 'Peruuttaa itsetarkastus',
      handleImage: 'Käsittele kuvia ',
      showAttachments: 'Näytä liitteet',
      updateSelfInspectionErrorMessage:
        'Itsetarkistuksen tallentaminen epäonnistui',
      notApplicableText: 'Selitä syy, miksi sitä ei voida soveltaa',
      cancel: 'Peruuta',
      markAsNonApplicable: 'Merkitse ei-soveltuvaksi',
      notApplicable: 'Ei sovelleta',
      editNotApplicableComment: 'Muokkaa kuvausta',
      saveChanges: 'Tallenna muutokset',
      updateSelfInspectionSuccessMessage: 'Kuvaus tallennetaan ja päivitetään',
      selfInspectionSavedSuccessMessage: 'Itsetarkastus on tallennettu',
      revertSelfInspectionMessage: 'Itsetarkastus palautettu onnistuneesti',
      updateSelfInspectionFilesMessage:
        'Itsetarkastustiedostot päivitettiin onnistuneesti',
      updateSelfInspectionRevertedMessage: 'Kuvien lataaminen peruttiin',
      uploadSelfInspectionImageSuccess: 'Kuva ladattu!',
      uploadSelfInspectionImageError: 'Kuvaa ei voitu ladata. Yritä uudelleen!',
      deleteSelfinspectionImageSuccess: 'Kuva on poistettu.',
      deleteSelfinspectionImageError: 'Kuvaa ei voitu poistaa.',
      loadingImages: 'Ladata kuvia...',
      instructionalImage: {
        DepthExampleImage: 'Sisällytä viivain valokuvaan - Katso esimerkki',
      },
      done: 'Tehty: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Muutoksesi on tallennettu',
    updateInstallationReportError: 'Muutoksiasi ei voitu tallenna',
    clearDate: 'Tyhjennä päivämäärä',
    alerts: {
      executedDateAlert: 'Varmista, että kaikki itsetarkastukset on suoritettu',
      signReady: 'Valmiina allekirjoitettavaksi',
    },
    imageChecklist: {
      title: 'Kuvan tarkistuslista',
      listItems: {
        splicingOutlet: 'Kuva liitoksesta kuituulostulossa/julkisivulaatikossa',
        splicingFOS: 'Kuva liittämisestä FOS:ssa',
        sealingDuctFOS: 'Kuva tiivistyskanavasta FOS:ssa',
        hasOdfPortImage: 'Kuva ODF-portista',
        hasSwitchPortImage: 'Kuva Switchportista',
        hasNodeImage: 'Before and after image in site',
      },
    },
  },
  macAddressInvalid: 'Virheellinen MAC-osoite',
  Huvudbyggnad: 'Päärakennus',
  Extraanslutning_seperat_byggnad: 'Lisäasennus eri rakennukseen',
  Extraanslutning_inom_huvudbyggnad: 'Lisäasennus päärakennuksessa',
  datepickerPlaceholder: 'YYYY-MM-DD',
  imagePreview: {
    upload: 'Lataa',
    cancel: 'Peruuta',
    header: 'Kuvan esikatselu',
    noImages: 'Ei kuvia näytettäväksi',
    loadingImages: 'Ladata kuvia...',
  },
  imagePreviewV2: {
    preview: 'Esikatselu',
    addImages: 'Lisää kuvia',
    close: 'Sulkea',
    downloadAll: 'Lataa kaikki',
    editImages: 'Muokata kuvia',
    manageImages: 'Hallitse kuvia',
    done: 'Valmis',
    deleteImageQuestion: 'Poista kuva?',
    confirmDelete: 'Kyllä, poista',
    cancel: 'Peruuttaa',
    confirmDeleteText: 'Haluatko varmasti poistaa tämän kuvan?',
    pleaseWait: 'Odota...',
    download: 'Lataa',
    images: 'Kuvia',
    imageDeleted: 'Kuva on poistettu',
    saved: 'Tallennettu!',
    uploaded: 'Ladattu',
    noImagesAvailable: 'Ei kuvia saatavilla',
    addImagesBelow: 'Voit lisätä kuvia alle!',
  },
  dateFormatError: 'Olet kirjoittanut väärän päivämäärän (YYYY-MM-DD).',
  tableConfiguration: {
    title: 'Konfiguroi taulukko',
    cancel: 'Peruuta',
    apply: 'Lisää',
    showAllColumns: 'Näytä kaikki sarakkeet',
  },
  ...months,
  ...weekdays,
  workSectionStatus: {
    EXECUTED: 'Suoritettu',
    PLANNED: ' Suunniteltu',
    AWAITING_PLANNING: 'Odottaa suunnittelua',
    INCOMPLETE: 'Epätäydellinen',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'Työ on valmis',
    PLANNED: 'Työ on suunniteltu, mutta ei vielä valmis',
    AWAITING_PLANNING: 'Työtä ei ole vielä suunniteltu',
    INCOMPLETE: 'Souritettu puutteellisilla itsetarkastuksilla',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Ei yhteyttä',
  },
  fileUpload: {
    error: 'Tiedostoja ei pystytty lataamaan ',
    loadingImages: 'Ladata kuvia...',
  },
  select: 'Valitse ',
  tableFilter: {
    orderFilterssSectionHeader: ' valitut suodattimet',
    addFilterButton: 'Lisää suodatin',
    applyFilterButton: 'Käytä suodatinta',
    clearAllFiltersButton: 'Tyhjennä kaikki suodattimet',
    noFilteredOrders: 'Tilauksia ei löytynyt.',
    accessId: {
      existing: 'NetAdmin ID - Nykyinen',
      notExisting: 'NetAdmin ID - Ei ole olemassa',
    },
    plotDesign: {
      planned: 'Tonttisuunnittelu - Suunniteltu',
      awaitingPlanning: 'Tonttisuunnittelu - Odottaa suunnittelua',
      executed: 'Tonttisuunnittelu - Suoritettu',
    },
    preinstallation: {
      planned: 'Esiasennus - Suunniteltu',
      awaitingPlanning: 'Esiasennus - Odottaa suunnittelua',
      executed: 'Esiasennus - Suoritettu',
    },
    plotExcavation: {
      planned: 'Tonttikaivuu - Suunniteltu',
      awaitingPlanning: 'Tonttikaivuu - Odottaa suunnittelua',
      executed: 'Tonttikaivuu - Suoritettu',
    },
    ductConnection: {
      connected: 'Kanavakytkennät - Yhteyttä',
      notConnected: 'Kanavakytkennät - Ei yhteyttä',
    },
    cableBlowing: {
      planned: 'Kuidun puhallus - Suunniteltu',
      awaitingPlanning: 'Kuidun puhallus - Odottaa suunnittelua',
      executed: 'Kuidun puhallus - Suoritettu',
    },
    measuring: {
      planned: 'Hitsaus & Mittaus - Suunniteltu',
      awaitingPlanning: 'Hitsaus & Mittaus - Odottaa suunnittelua',
      executed: 'Hitsaus & Mittaus - Suoritettu',
    },
    commission: {
      planned: 'Käyttöönotto - Suunniteltu',
      awaitingPlanning: 'Käyttöönotto - Odottaa suunnittelua',
      executed: 'Käyttöönotto - Suoritettu',
    },
    perPage: 'Näytä per sivu: ',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Ladattu',
      success: 'Ladattu',
      error: 'Epäonnistui. Yritä uudelleen',
      signatureAlreadyExist: 'Allekirjoitus on jo olemassa. Poista ensin',
      couldNotConfirm: 'Ei voitu vahvistaa. Yritä uudelleen',
    },
    undoSelfInspection: {
      success: 'Kumottu',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    markAsNA: {
      success: 'Merkitty N/A',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    save: {
      success: 'Tallennettu',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    remove: {
      success: 'Poistettu',
      error: 'Epäonnistui. Yritä uudelleen',
    },
    get: {
      signatureError: 'Nouto epäonnistui. Yritä uudelleen',
      downloadError: 'Lataus epäonnistui. Yritä uudelleen',
      preparingDownload: 'Valmistellaan latausta, ole hyvä ja odota...',
    },
  },
  signing: {
    header: 'Allekirjoitus',
    back: 'Takaisin',
    confirm: 'Vahvistaa',
    CONTRACTOR: 'Urakoitsija',
    CUSTOMER: 'Asiakas',
    signAsCONTRACTOR: 'Allekirjoita yrittäjäksi',
    signAsCUSTOMER: 'Allekirjoita asiakkaaksi',
    infoText:
      'Lisää molemmat allekirjoitukset ja vahvista allekirjoitus loppuun.',
  },
  signingSummary: {
    customerInformation: 'Asiakkaan tiedot',
    address: 'Katuosoite',
    propertyDesignation: 'Kiinteistötunnus',
    name: 'Koko nimi',
    email: 'Sähköposti',
    mobileNumber: 'Matkapuhelinnumero',
    homeNumber: 'Kotipuhelinnumero',
    plotDesign: 'Tonttisuunnittelu',
    executedDate: 'Toteutuspäivämäärä',
    selfInspections: 'Suunnittelun aikana on käyty läpi seuraavat vaiheet',
    notApplicable: 'Ei sovelleta',
    comment: 'Kommentit',
    confirming: 'Vahvistaa...',
  },
  signingConfirmationModal: {
    headerTitle: 'Vahvistettu',
    return: 'Takaisin raporttiin',
    download: 'Lataa kopio',
    title: 'Kaikki on valmista!',
    paragraph: 'Kopio on lähetetty sähköpostiin.',
    paragraphV2: 'Allekirjoitettu kopio voidaan ladata!',
  },
  signaturePad: {
    clear: 'Poistaa',
    close: 'Lopettaa',
    save: 'Tallentaa',
    remove: 'Poista allekirjoitus',
  },
  signingCard: {
    title: 'Tonttisuunnitelman allekirjoittaminen',
    information:
      'Suorita kaikki vaaditut itsearvioinnit ja syötä suoritettu päivämäärä allekirjoituksen mahdollistamiseksi.',
    startSigning: 'Aloita allekirjoittaminen',
    newSigning: 'Uusi allekirjoitus',
  },
  signingErrorScreen: {
    reportDoesNotExist: 'Tätä raporttia ei ole olemassa',
    unableToStartSigning: 'Ei voida aloittaa allekirjoitusta!',
    reportMissingData:
      'Raportilta puuttuu suoritettu päivämäärä tai sillä on puutteellisia itsearviointeja.',
    goToReport: 'Mene raportoimaan',
    signingCouldNotBeStarted: 'Allekirjoitusta ei voitu aloittaa!',
    refreshOrTryAgain: 'Päivitä tai yritä myöhemmin uudelleen.',
    refreshPage: 'Päivitä sivu',
  },
  rotateDeviceMessage: 'Käännä laitetta vaakasuoraan',
  copied: 'Kopioitu',
  portConnectionStatus: {
    portConnection: 'Portin liitäntä',
    noMac: 'Preasennuksessa ei ole kelvollista MAC-osoitetta tai sarjanumeroa.',
    toPreinstallation: 'Siirry esiasennukseen',
    checkStatus: 'Tarkista portin liitännän tila.',
    checkConnection: 'Tarkista yhteys',
    loadingState: 'Tarkistetaan tilaa. Odota…',
    linking: 'Yhdistetty',
    notLinking: 'Ei yhdistetty',
    installationDate: 'Asennuspäivämäärä: ',
    checkAgain: 'Tarkista uudelleen',
    debugMessage: 'Vianmääritystä ja yritä tarkistaa uudelleen.',
  },
  pageSizepicker: { all: 'Kaikki' },
  tabletoolBar: {
    building: 'Rakentaminen',
    deliveryPoint: 'Toimituspiste',
    itemsPerPage: 'Kohteita sivulla',
    search: 'Haku',
    searchPlaceholder: 'Haku',
  },
  installationReportingMduTable: {
    legend: {
      building: 'Rakennus',
      deliveryPoint: 'Toimituspiste',
    },
    constructionStatus: {
      PLANNED: 'Suunniteltu',
      HANDED_TO_CONSTRUCTION: 'Luovutettu rakennukseen',
      STARTED: 'Aloitettu',
      FINISHED: 'Valmis',
      OBSTRUCTION: 'Este',
      MIGRATION_ONGOING: 'Migraatio käynnissä',
      MIGRATED: 'Migroitu',
    },
    headers: {
      buildingName: 'Rakennuksen nimi',
      status: 'Tila',
      macAccessId: 'MAC ja Access ID',
    },
    labels: {
      macAddress: 'MAC:',
      accessId: 'Access ID:',
    },
    status: {
      inProgress: 'Käynnissä',
      approved: 'Hyväksytty',
      completed: 'Valmis',
      underReview: 'Tarkastettavana',
      notApplicable: 'Ei sovelleta',
    },
  },
  installationReportingMduModal: {
    header: 'Asennusraportti',
  },
  buildingPageModal: {
    header: 'Asennusraportti rakennus',
    deliveryProject: 'Toimitusprojekti',
    comment: 'Kommentti',
    commentPlaceholder: 'Kirjoita jotain...',
    commentPlaceholderPhase: 'Kirjoita kommentti...',
    sectionNotApplicable: {
      markAsNotApplicable: 'Merkitse soveltumattomaksi',
      reasonLabel: 'Lisää syy soveltumattomuudelle',
      reasonPlaceholder: 'Kirjoita syy...',
      cancel: 'Peruuta',
      tag: 'EI SOVELLU',
      commentTitle: 'Kommentti',
      by: 'Tekijä',
      reactivate: 'Aktivoi omavalvonta uudelleen',
      saveError: 'Osion soveltumattomuuden päivitys epäonnistui.',
    },
    optional: 'Valinnainen',
    uploadedFileCount: 'Ladatut tiedostot: ',
    signing: {
      performedBy: 'Allekirjoituksen suorittaa',
      deliveryContact: 'Toimituksen yhteyshenkilö',
    },
    selfInspections: {
      plotDesign: {
        item1: 'Tarkista, että tonttisuunnitelma vastaa asennusolosuhteita.',
        item1_1:
          'Tarkista, että tarvittavat luvat ja hyväksynnät ovat kunnossa.',
        item2: 'Merkitse kaapelireitti ja liitäntäpiste.',
        item2_1: 'Tarkista, että merkitty reitti on vapaa asennusta varten.',
        item3:
          'Tarkista, että tarvittavat materiaalit ja laitteet ovat käytettävissä.',
        item4: 'Tarkista asiakkaan laitteen suunniteltu sijoitus.',
        item6: 'Dokumentoi poikkeamat tonttisuunnitelmasta.',
        item7: 'Ota kuva valmiista tonttisuunnitelmasta.',
        item7_1: 'Tarkista, että kuvallinen dokumentaatio on täydellinen.',
        item8: 'Tarkista, että soveltuvat turvallisuusvaatimukset täyttyvät.',
        item10: 'Dokumentoi muut olennaiset tiedot.',
      },
      preinstallation: {
        item1: 'Tarkista CPE- tai ONT-laitteen sijoitus.',
        item2: 'Tarkista virtalähde.',
        item3: 'Ota kuva CPE- tai ONT-laitteen sijoituksesta.',
        item4: 'Ota kuva kaapelireitistä.',
        item5: 'Ota kuva kuiturasiasta.',
        item6: 'Ota kuva laitteen merkinnästä.',
      },
      plotExcavation: {
        item1: 'Ota kuva kaivureitistä.',
        item2: 'Ota kuva kaivusyvyydestä.',
        item2_1: 'Ota kuva varoitusnauhasta.',
        item3: 'Ota kuva palautetusta pinnasta.',
      },
      ductConnection: {
        item1: 'Ota kuva liitetyistä putkista.',
      },
      cableBlowing: {
        item1: 'Ota kuva kaapelinpuhallusasennuksesta.',
        item1_extra: 'Varmista, että kaapelimerkinnät näkyvät kuvassa.',
      },
    },
    notImplementedYet: 'Ei viela toteutettu. Muutoksia ei tallenneta.',
  },
};
